"use client"

import { useBreakpoint } from "@/lib/hooks/useBreakpoint"
import type React from "react"

import type { BlogDetail } from "@/lib/types/blog/detail"
import type { CourseDetail } from "@/lib/types/course/detail"
import {
	BlogCard,
	CourseDetailCard,
	CourseGridCard,
	type IGridItemProps,
} from "./gridItems"
import { Price } from "./price"
import { COURSE_STATUS } from "@/lib/constants/course"

const GridItem: React.FC<IGridItemProps> = ({
	data,
	type = "course",
	tags = false,
	showMore = false,
	priority = false,
	showDetail = true,
}) => {
	const { breakpoint } = useBreakpoint()

	if (!data) return null

	if (type === "blog") {
		return <BlogCard data={data as BlogDetail} tags={tags} />
	}

	// Course type handling
	const courseData = data as CourseDetail
	let contentPrice = Price.getContentPrice(courseData)
	if (!showDetail) {
		contentPrice = Price.getContentPrice({
			...courseData,
			status: {
				status: COURSE_STATUS.GIFTED,
				all_status: COURSE_STATUS,
			},
		})
	}
	const discountContent = Price.discount(courseData)
	const discountContentCard = Price.discountCard(courseData)

	const content = <CourseDetailCard data={courseData} />
	if (!content) return null

	const cardContent = (
		<CourseGridCard
			data={courseData}
			contentPrice={contentPrice}
			discountContentCard={discountContentCard}
			priority={priority}
			showDetail={showDetail}
		/>
	)

	return breakpoint === "xs" ? cardContent : <>{cardContent}</>
}

export default GridItem
